import { Module } from 'vuex';
import { SettingState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: SettingState = {
    systemSetting: undefined,
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const setting: Module<SettingState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
